<div class="mx-auto w-full">
  <!-- <div class="header">
    <div>
      <h1 class="title">SUIVI ÉQUIPEMENTS POUR ENTRETIEN</h1>
      <p class="subtitle">
        L'état de santé des actifs est actualisé toutes les 24 heures.
      </p>
    </div>
  </div> -->

  <div class="grid grid-cols-1 lg:grid-cols-1 2xl:grid-cols-1 gap-6">
    <app-asset-group [Rules]="pagedRules" />
  </div>
</div>
